module.exports = {"data":[{"url":"https://image.yunduoketang.com/headpic/137249/20200731/95ca3878-08ce-4867-9586-1df3de4153a7.png","teacherName":"王丽鲜","fraction":"0","classOpen":"5","students":"10","subject":"主要培训项目以母婴健康为主，覆盖多项技能培训项目，包含产康师、催乳师、育婴师、健康管理师等内容，并承接大型母婴公司团体课程，同时为健康行业输出具有培训资质的讲师团队。领澜•伟亿理论课程全面权威，自营产康门店实习，教学以系统理论+真人实操+门店实践+入户实习+精品培训，全新的五位一体教学模式。"}]}


//////////////////
// WEBPACK FOOTER
// ./mock/teacher.json
// module id = IJ6Z
// module chunks = 1